<template>
    <div id="skip" class="wrapper--skip">
        <a 
            href="#main" 
            class="skip-link" 
            :tabindex="tabindex" 
            @click.prevent="moveFocus"
        >
            <slot />
        </a>
    </div>
</template>

<script>
const q = (e) => document.querySelector(e)

export default {
    computed: {
        tabindex() {
            const { menu, visible } = this.$store.state

            if ( !menu.opened && !visible.stories ) return undefined

            return '-1'
        },
    },
    methods: {
        moveFocus() {
            const mainContent = q('#main') || q('section')
            mainContent.setAttribute('tabindex', '-1')
            mainContent.focus()
        },
    },
}
</script>

<style scoped>
a {
    background: #fff;
    outline: 2px dashed var(--purple);
    padding: .2rem .8rem;
    display: inline-block;
    position: absolute;
    top: -2.5rem;
    left: .25rem;
    z-index: 11;
    transition: top .2s;
}
a:focus {
    top: .25rem; 
}
</style>